import React from 'react';

import {displayAmountMerchant} from '../../utils/displayAmountData';
import TableItemWithSubtitle from '../../../TableItemWithSubtitle';

const displayAmountFCCtor = (C) => ({fiat = {}, crypto = {}}) => {
  return (
    <TableItemWithSubtitle
      item={<C {...fiat} type="fiat" />}
      subItem={!!crypto.amount && !!crypto.symbol && <C {...crypto} type="coin" />}
    />
  )
};

module.exports = {
  // DisplayAmountFCAdmin: displayAmountFCCtor(displayAmountAdmin),
  DisplayAmountFCMerchant: displayAmountFCCtor(displayAmountMerchant)
};
